import React, { Component } from "react";
import { BarChart, Card } from "ui-kit-ck-consultant";

export class Rendement extends Component {
  getMax = (array1, array2 = null) => {
    let max = 0;
    array1.map((item) => {
      if (parseInt(item) > max) max = parseInt(item);
      return true;
    });
    array2 &&
      array2.map((item) => {
        if (parseInt(item) > max) max = parseInt(item);
        return true;
      });
    return max + (max / 100) * 20;
  };

  render() {
    return (
      <Card className={"mt-30"} title={"Rendemment"}>
        <BarChart
          type="bar"
          title={"Rendement Mois / Mois"}
          labels={this.props.data.labels}
          dataSet={[
            {
              label: "Rendement (en %)",
              data: this.props.data.rendement.rendementByMonth,
              type: "line",
              color: "#6067AE",
              yAxisID: "A",
            },
            {
              label: "Dossiers reçus",
              data: this.props.data.rendement.dossiersRecusByMonths,
              type: "bar",
              color: "#E68A00",
              yAxisID: "B",
            },
            {
              label: "Dossiers déposés",
              data: this.props.data.rendement.dossiersDeposesByMonth,
              type: "bar",
              color: "#51AE50",
              yAxisID: "B",
            },
          ]}
          yAxes={[
            {
              id: "A",
              display: false,
              dataLabelsOptions: { display: true },
              ticks: {
                suggestedMax: this.getMax(
                  this.props.data.rendement.rendementByMonth
                ),
                beginAtZero: true,
              },
            },
            {
              id: "B",
              display: false,
              ticks: {
                suggestedMax: this.getMax(
                  this.props.data.rendement.dossiersRecusByMonths,
                  this.props.data.rendement.dossiersDeposesByMonth
                ),
                beginAtZero: true,
              },
            },
          ]}
        />
      </Card>
    );
  }
}

export default Rendement;
